
const getters = {
  tag: state => state.tags.tag,
  website: state => state.common.website,
  isCollapse: state => state.common.isCollapse,
  opened: state => state.common.opened,
  templateCollapse: state => state.common. templateCollapse,
  isLock: state => state.common.isLock,
  isFullScren: state => state.common.isFullScren,
  lockPasswd: state => state.common.lockPasswd,
  tagList: state => state.tags.tagList,
  tagCurrent: state => state.tags.tagCurrent,
  tagWel: state => state.tags.tagWel,
  accessToken: state => state.user.accessToken,
  refreshToken: state => state.user.refreshToken,
  userInfo: state => state.user.userInfo,
  isReadOnly: state => state.user.userInfo.isReadOnly,
  roles: state => state.user.roles,
	cusLogo: state => state.user.cusLogo,
	themeType: state => state.user.themeType,
  setting: state => state.user.setting,
  loadingStatus: state => state.common.loadingStatus,
  clientWidth: state => state.screen.clientWidth,
  clientHeight: state => state.screen.clientHeight,
  tableSize: state => state.screen.tableSize,
  workspaceRect: state => state.screen.workspaceRect,
  dicts: state => state.common.dicts,
  menu: state => state.user.menu,
  ygj: state => state.user.ygj,
  isYgj: state => state.user.isYgj,
  pass: state => state.user.pass,
  pms: state => state.user.pms,
  branchInfo: state => state.user.branchInfo,
  cusId: state => state.user.cusId,
  cusList: state => state.user.cusList,
  cusListTotal: state => state.user.cusListTotal,
  clientInfo: state => state.user.clientInfo,
  memberInfo: state => state.user.memberInfo,
  authorizedAgencies: state => state.user.authorizedAgencies,
  authorizedMembers: state => state.user.authorizedMembers,
  color:state => state.common.color,
  lang: state => state.common.lang,
  step2Info:state => state.data.step2Info,
  filterRoutes: state => state.user.filterRoutes,
  loadingMenu: state => state.user.loadingMenu,
  systemData: state => state.user.systemData,
  permissionRoutes: state => state.permission.routes,
  permissionAddRoutes: state => state.permission.addRoutes,
  colorListBar: state => state.echarts.colorListBar,
  colorListPie: state => state.echarts.colorListPie,
  colorListTrend: state => state.echarts.colorListTrend
};
export default getters;
